import {useQuery} from "@tanstack/react-query";
import {getUserManagementUserQueryOptions} from "./get-user-management-user.query-options";

export function useGetUserManagementUser(userId: string) {
  return useQuery(getUserManagementUserQueryOptions(userId));
}
